import {
  FINGERSPELLING_SIDES,
  FINGERSPELLING_SIDE_LABELS,
  type FingerspellingSide,
} from "../../lib/fingerspelling";

type SideSwitchProps = {
  value: FingerspellingSide;
  onChange: (side: FingerspellingSide) => void;
};

/** 「あいてから見た手 / じぶんから見た手」の切替スイッチ */
export const SideSwitch = ({ value, onChange }: SideSwitchProps) => (
  <div className="flex overflow-hidden rounded-xl border border-neutral-300 bg-white text-sm">
    {FINGERSPELLING_SIDES.map((side) => (
      <button
        key={side}
        type="button"
        aria-pressed={value === side}
        onClick={() => onChange(side)}
        className={`flex-1 select-none touch-manipulation px-3 py-2 [-webkit-touch-callout:none] ${
          value === side
            ? "bg-neutral-900 font-semibold text-white"
            : "text-neutral-700"
        }`}
      >
        {FINGERSPELLING_SIDE_LABELS[side]}
      </button>
    ))}
  </div>
);
